import { SvgIconDefinition } from '@am/icons-common-types';
const width = 128;
const height = 128;
const path = `M94.9,84.9V37.2L111.8,61C111.8,61,94.9,84.9,94.9,84.9z M105.9,23.6H22.1c-8,0-14.6,6.5-14.6,14.6c0,0,0,0,0,0v51c0,8,6.5,14.6,14.6,14.6h83.7c8,0,14.6-6.5,14.6-14.6v-51C120.4,30.1,113.9,23.6,105.9,23.6C105.9,23.6,105.9,23.6,105.9,23.6L105.9,23.6z`;

export const aciCardKey: SvgIconDefinition = {
  iconName: 'card-key',
  iconData: [height, width, path],
};
